"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleOptions;

var _useStyleSet = _interopRequireDefault(require("./useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useStyleOptions() {
  // Today, the "styleSet.options" is patched with missing values and "styleOptions" are unpatched.
  // Thus, we are using the "styleSet.options" version for now.
  return [(0, _useStyleSet.default)()[0].options];
}